 
import Form from "./forms/form"; 
import SecondaryButton from "./common/secondary-btn";
import { TypeAnimation } from "react-type-animation";

export default function Banner({ setThankModal, toggleModal, id }) {
  return (
    <section
      id={id}
      className="relative block w-full lg:pt-32 pb-7 lg:pb-[16] pt-[120px] banner-top"
      style={{
        background: "url(https://glocify.com/images/banner-hero.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition:'bottom center'
      }}
    >
      <style>

        {`
        @media only screen and (max-width:768px)
        {
        .banner-top {
    background-position: 30% center !important;
}
        }
        `}
      </style>
      <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
        <div className="lg:flex lg:grid-cols-2 gap-4 lg:gap-y-0 gap-y-6">
          <div className="lg:w-[63%]  lg:mb-0 mb-8  lg:text-left text-center md:text-center flex flex-wrap lg:items-center justify-center lg:justify-start pb-[40px] lg:pb-0 md:pb-0">  
            <div className=" mb-[40px]  sm:w-[100%]">   
            <h1
              data-aos="fade-up"
              data-aos-duration="1500"
              className="lg:text-[60px] md:text-[45px] text-[30px] font-semibold text-white  tracking-normal leading-[1.2] mb-3  lg:text-left text-center banner-title"
            >
              Hire Stripe Expert for <br></br>  
              <TypeAnimation 
                sequence={[
                  "M2 Reader Integration",
                  1000,
                  "Stripe Connect Integration",
                  1000,
                  "Marketplace Integration",
                  1000,
                  
                ]}
                wrapper="span"
                speed={50}
                className="text-[#fe963a] lg:block hidden"
                repeat={Infinity}
              />
                <TypeAnimation 
                sequence={[
                  "M2 Reader Integration",
                  1000,
                  "Stripe Integration",
                  1000,
                  "Marketplace Integration",
                  1000,
                  
                ]}
                wrapper="span"
                speed={50}
                className="text-[#fe963a] lg:hidden block"
                repeat={Infinity}
              />
            </h1>      
            <p className="max-w-[560px] text-white leading-normal lg:mx-0 mb-7 md:mx-auto sm:mx-auto ">Hire an expert Stripe developer for all your Stripe integration needs, whether it's for web, mobile, or hardware applications.</p> 
            <SecondaryButton
                    title="Talk to an Expert"
                    toggleModal={toggleModal}
                  />  
                  </div>  
          </div>
          <div className="lg:w-[33%] md:w-[80%] md:mx-auto hidden lg:block md:block ">
            <div
              id="bannerForm"
              className="bg-[linear-gradient(45deg,#F16500_-3.51%,#FF9A3E_92.34%)] py-[28px] px-[24px] rounded-[32px]  bannerForm"
              data-aos="fade-left"
              data-aos-duration="2500"
            >
              <h3 className="font-semibold text-white text-[26px] md:text-center pb-[10px]">
              Hire a Stripe Expert Today!
              </h3>
              {/* <h2 className="text-[16px] font-medium text-white mb-4  md:text-center">
              Upgrade payments with our Stripe experts.
              </h2> */}
              <Form contactformid="19131" setThankModal={setThankModal} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
